<template>
  <div class="edit standing">
    <div class="standing-bar">
      <el-row>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(1)"
                   @click="editStart = false">修改
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(2)"
                   @click="checkForm">保存
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-audit"
                   @click="btnConfirm(doOperate,'1','确认审核此提单？',0)"
                   :disabled="buttonStart(3)">
          审核
        </el-button>
        <el-button type="danger" size="small" icon="el-hg-icon-delete"
                   @click="btnConfirm(doOperate,'3','确认作废此提单？')"
                   :disabled="buttonStart(4)">
          作废
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-icon-back" @click="doCancleAudit" :disabled="buttonStart(3)">退审</el-button>-->
        <!--<el-button type="primary" size="small" icon="el-icon-circle-check" @click="doFinish" :disabled="buttonStart(4)">完成</el-button>-->
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="detail(id)"
                   :disabled="buttonStart(5)">刷新
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-hg-icon-downloadf" :disabled="buttonStart(5)">导出</el-button>-->
        <el-button type="primary" size="small" icon="el-icon-paperclip" @click="enclosureStart = !enclosureStart">附件
        </el-button>
      </el-row>
    </div>
    <div :class="[editStart ? 'standing_conter': 'standing_conter editStart']"
         :style="{height: editModleHeight + 'px'}">
      <div class="edit_from">
        <el-form :model="formInline" class="top-form" ref="topForm" :rules="rules" label-width="110px" size="mini">
          <el-form-item v-for="(itme, key) in fromList" :key="key" :prop="itme.key"
                        :class="[itme.type==='switch'?'halfW':'',itme.width==='all'?'allW':'']">
            <span slot="label">
              <span v-if="itme.must"><span style="color: red">*</span>
                {{itme.label}}
              </span>
              <span v-else>{{itme.label}}</span>
            </span>
            <el-input v-if="itme.type === 'input'" v-model="formInline[itme.key]" placeholder="请输入内容"
                      :type="itme.contentType==='number'?'number':'text'" :clearable="itme.key!=='AvailableDays'"
                      :class="[itme.contentType==='number'?'alignRight':'']"
                      :disabled="itme.disabled"/>
            <el-input v-if="itme.type === 'inputButton'" style="width: 100%" v-model="formInline[itme.key]" clearable
                      :disabled="itme.disabled" placeholder="请输入内容">
              <el-button slot="append" v-if="itme.tips" @click="openDialog(itme.dialog)" icon="el-icon-more"
                         :disabled="itme.disabled"></el-button>
            </el-input>
            <el-select v-if="itme.type === 'select'" allow-create clearable :disabled="itme.disabled" filterable
                       v-model="formInline[itme.key]" placeholder="请输入内容">
              <el-option
                v-for="(value, key) in itme.list"
                :key="key"
                :label="value[itme.labelName]"
                :value="value[itme.value]">
                <div v-if="itme.key==='BargainID'">
                  <span>{{value.BargainID}}
                    有效期：{{$utils.getTimeToDay(value.BeginDate)}}-{{$utils.getTimeToDay(value.EndDate)}}</span>
                </div>
              </el-option>
            </el-select>
            <el-date-picker
              :disabled="itme.disabled"
              v-if="itme.type === 'datePicker'"
              v-model="formInline[itme.key]"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"></el-date-picker>
            <!--:picker-options="pickerOptionsEnd(itme.key)"-->
            <el-switch
              :disabled="editStart"
              v-if="itme.type === 'switch'"
              v-model="formInline[itme.key]"
              active-color="#13ce66">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div class="edit_table">
        <div class="tableCon" :style="batchNumberListHeight">
          <div class="tableContent-title">货物明细</div>
          <div class="tableContent" :style="batchNumberListStyle">
            <div class="tableContent-pane">
              <div class="edit_header">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-plus" :disabled="editStart"
                             @click="addNewBatchNumberData"></el-button>
                </el-tooltip>

                <!--<el-button size="small" type="primary" icon="el-icon-edit" ></el-button>-->
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-delete" :disabled="editStart"
                             @click="batchNumberDelete"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新列表" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-refresh" :disabled="editStart"
                             @click="batchdetail(id)"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-upload" :disabled="editStart" @click="complete"></el-button>-->
              </div>
              <sp-table
                ref="batchTable"
                :parentTableData.sync="batchFilterData"
                :parentCol.sync="batchNumberCol"
                :dragDrop='true'
                @addNewData="addNewBatchNumberData"
                @selection-change="batchNumberSelectionChange"
                :is-edit="!editStart"
                :summary-data="summaryData"
                show-summary
                :summary-method="getSummaries"
                :tableUID="'batchTable'"
                class="batchTable"
              >
                <el-table-column align="center" type="selection" class="selection"></el-table-column>
                <el-table-column align="center" label="序号" type="index" width="50"/>
                <sp-table-column :align="item.titleAlignment" v-for="(item, index) in batchNumberCol" :key="index"
                                 :prop="batchNumberCol[index].field"
                                 :width="item.width">
                  <template slot="header">
                    <p><b style="color: red" v-if="!item.isNull">*</b>
                      {{item.title}}</p>
                  </template>
                  <template v-slot="{ scope }">
                    <div class="auto-input" v-if="!item.readOnly">
                      <div v-if="carOrderBatchComponent.select.indexOf(item.field) > -1 ">
                        <el-select v-model="scope.row[batchNumberCol[index].field]" placeholder="请选择"
                                   v-show="item.field==='BargainID'"
                                   @change="selectOpt(scope)">
                          <el-option
                            v-for="(l,Ti) in TankIDListFilter"
                            :key="Ti"
                            v-show="batchFilterData.findIndex(v=>v.TankID===l.TankID)<0"
                            :label="l.TankID"
                            :value="l.TankID">
                            <span style="margin-right: 2em">罐号：{{l.TankID}}</span>
                            <span v-if="orderType==='load'">可提数：{{ l.CanNumber }}</span>
                          </el-option>
                        </el-select>
                      </div>
                      <div align="center" v-else-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]"></el-checkbox>
                      </div>
                      <div v-else-if="carOrderBatchComponent.inputButton.indexOf(item.field) > -1">
                        <el-input size="mini" v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容">
                          <el-button slot="append"
                                     @click="openDialog('showBargainID', scope,batchNumberList)"
                                     icon="el-icon-more"></el-button>
                        </el-input>
                      </div>
                      <div v-else>
                        <el-input size="mini" :type="[3,6,8].indexOf(item.fieldType) >=0?'number':''"
                                  v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <div :class="[item.readOnly ? 'span spanEdit' : 'span']">
                      <div align="center" v-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]" :disabled="true"></el-checkbox>
                      </div>
                      <p v-else :align="item.alignment">{{scope.row[batchNumberCol[index].field]}}</p>
                    </div>
                  </template>
                </sp-table-column>
              </sp-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <grid-dialog :show="showBargainID"
                 title="罐号选择"
                 :default-params="BargainIDDefaultParams"
                 :grid-config="BargainIDByConditions"
                 :default-values.sync="BargainDefaultValue"
                 :dataUpdate="dataUpdate"
                 :default-keys="BargainDefaultKey"
                 :ref-list.sync="batchNumberList"
                 :ref-list-index.sync="currentTank"
                 @close="showBargainID = !showBargainID"></grid-dialog>
    <Dialog title="附件" :width="600" :height="400" :visible="enclosureStart" @close="enclosureStart = !enclosureStart">
      <div class="grid-contain dialog edit">
        <div style="margin-bottom: 20px" v-if="buttonStart(10)">
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="uploadFileDesc = !uploadFileDesc">上传文件
          </el-button>
        </div>
        <div class="grid-table">
          <sp-table
            ref="batchTable"
            :parentTableData.sync="annexDetailList"
            :parentCol.sync="enclosureAction">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" label="序号" type="index" width="50"/>
            <sp-table-column v-for="(item, index) in enclosureAction" :key="index" :width="item.width">
              <template slot="header">
                <p>{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" v-if="item.field !== 'edit'">
                  <p>{{scope.row[enclosureAction[index].field]}}</p>
                </div>
                <div class="span" v-else>
                  <el-button type="primary" size="small" @click="fileDownload(scope.row)">下载
                  </el-button>
                  <el-button type="danger" v-if="buttonStart(10)" size="small" @click="fileDelete(scope.row)">删除
                  </el-button>
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </Dialog>
    <Dialog title="上传文件说明" :width="400" :height="100" :visible="uploadFileDesc"
            @close="uploadFileDesc = !uploadFileDesc">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px">
          <el-form-item label="描述" class="required">
            <el-input v-model="desc" placeholder="请输入说明后再选择文件"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-upload
            class="upload-demo"
            action=""
            name="file"
            :show-file-list="false"
            :http-request="beforeAvatarUpload">
            <el-button size="small" :disabled="!desc" icon="el-hg-icon-save" type="primary">选择文件</el-button>
          </el-upload>
          <el-button size="small" icon="el-hg-icon-close" type="danger" @click="uploadFileDesc = !uploadFileDesc"
                     style="margin-left: 20px">关 闭
          </el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import {spTable, spTableColumn} from '@/components/sptable';
  import dayjs from 'dayjs';
  import gridDialog from '@/components/gridDialog';
  import Dialog from '@/components/dialog';
  import storageM from '@/storage';
  import {Loading} from 'element-ui';

  const storage = storageM['sessionStorage'];

  export default {
    name: 'edit',
    components: {
      spTable,
      spTableColumn,
      gridDialog,
      Dialog,
    },
    data() {
      return {
        summaryData: '',
        Codephone: '',
        msgCode: '',
        msgCodeShow: false,
        dataUpdate: false,
        editStart: true, // 判断页面是否是编辑状态，所有可输入框是根据该字段判定
        id: '', // 订单唯一id
        type: '', // 页面入口进入不同，导致页面中的状态不同，根据状态判定页面页面是否可以编辑，是否添加，预览状态
        showGoodDic: false,
        showGuestId: false,
        showBargainID: false,
        showGoodsID: false,
        showgetTGuest: false,
        showLocation: false,
        showTankID: false,
        showTGuestID: false,
        showAttachBargain: false,
        enclosureStart: false,
        uploadFileStart: false,
        uploadFileDesc: false,
        goodDIcDefaultParams: {
          type: 'GUESTBUSINESS',
          url: this.OrderType ? 'getInCarRefGoods' : 'getOutCarRefGoods',
          params: {
            goodsId: '',
          },
        },
        batchNumberOriginData: {},
        licenseNumberOriginData: {},
        batchNumberList: [],
        licenseNumberList: [],
        bargainList: [],
        getRefGoodsList: [],
        locationList: [],
        guestIDList: [],
        getBlnoList: [],
        BargainList: [],
        outGuestIDList: [],
        rules: {
          GoodsID: [{
            required: true,
            message: '请选择产品',
            trigger: ['blur', 'change']
          }],
          InGuestID: [{
            required: true,
            message: '请选择划入客户',
            trigger: ['blur', 'change']
          }],
          OutGuestID: [{
            required: true,
            message: '请选择转出客户',
            trigger: ['blur', 'change']
          }]
        },
        formInline: {
          InGuestID: '',
          OutGuestID: '',
          ScullType: '0',
          GoodsID: '', // 产品id
          InBLNO: '',
          ScullDate: '',
          IsScullRight: 1,
          InBargainID: '',
          BearGuestID: '',
          ReasonWaste: '',
          IsScullFee: false,
          isnext: false,
          OperatorID: '',//制单人
          OperatorName: '',//制单人
          CreateDate: '',
          Remark: '',
          FreeDays: 0,
          IsLimit: 0
        },
        licenseNumberUserSelectId: [], // 批号选择id集合
        batchNumberUserSelectId: [], // 车号选择id集合
        detailInfo: {State: 0},
        getServiceIdList: [],
        MainOrder: '',
        guestIdDefaultValue: {
          Name: 'Name',
          GuestID: 'GuestID',
        },
        guestIdDefaultKeys: 'GuestId',
        goodsDefaultValue: {
          Name: 'CEGoodsName',
          GoodsID: 'GoodsID',
        },
        goodsDefaultKeys: 'GoodsID',
        BargainIDDefaultValue: {
          BargainID: 'BargainID',
        },
        locationDefaultValue: {
          BargainID: 'Location',
        },
        TGuestIDDefaultValue: {
          GuestID: 'GuestID',
        },
        TGuestIDDefaultKey: 'GuestID',
        BargainDefaultValue: {
          AccountID: 'AccountID',
          TankID: 'TankID',
          BargainID: 'BargainID',
          IsInTrade: 'IsInTrade',
          IsOutTrade: 'IsOutTrade',
          IsTax: 'IsTax',
          BatchNo: 'BatchNo',
          Number: 'LeftNumber',
          DeductNumber: 'OrderNumber',
          PassNo: 'PassNo',
          Remark: 'Remark',
        },
        BargainDefaultKey: 'GuestID',
        TGuestIDDefaultValue: {
          GuestName: 'TGuestName',
          GuestID: 'TGuestID',
        },
        TGuestIDDefaultKeys: 'TGuestID',
        currentTank: 0,
        bargainDefaultValue: {
          BargainID: 'BargainID',
        },
        bargainDefaultKeys: 'BargainID',
        AttachBargainDefaultValue: {
          BatchNo: 'Location'
        },
        AttachBargainDefaultKey: 'BatchNo',
        carOrderBatchComponent: {
          select: [],
          checked: ['IsInTrade', 'IsOutTrade', 'IsTax',],
          inputButton: ['BargainID',],
        },
        OrderType: false, // 判断是否是装车还是卸车
        batchNumberCol: [],
        licenseNumberClo: [],
        Step: '',
        fileUpload: '',
        desc: '',
        annexDetailList: [],
        editModleHeight: 0,
        batchNumberListStyle: {},
        batchNumberListHeight: {
          minHeight: '200px',
          marginBottom: '35px'
        },
        licenseNumberListHeight: {
          minHeight: '200px',
          marginBottom: '55px'
        },
        refGoodsList: [],
        TankIDList: [],
        orderType: '',
        licenseNumberInput: 0,
        currF: '',
        currFpar: '',
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        goodDicList: 'dictionary/goodDicList',
        guestIDByConditionsList: 'dictionary/guestIDByConditionsList',
        bargainIDByConditionsList: 'dictionary/bargainIDByConditionsList',
        refGoodsByConditionsList: 'dictionary/refGoodsByConditionsList',
        CargoTransferDetail: 'dictionary/CargoTransferDetail',
        carOrderList: 'dictionary/adminCarOrderListAction',
        TGuestIDByConditions: 'dictionary/TGuestIDByConditions',
        BargainIDByConditions: 'dictionary/BargainIDByConditions',
        visitedViews: 'tags/visitedViews',
      }),
      BargainIDDefaultParams() {
        let info = {
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_TankGoodsBargain',
          params: {
            accountId: this.userInfor.accountId,
            goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          },
        };
        return info;

      },
      TankIDListFilter() {
        let arr = [];
        console.log(this.TankIDList);
        this.TankIDList.forEach(v => {
          this.batchNumberList.forEach(itme => {
            if (v.BargainID && (v.BargainID !== itme.BargainID || itme.updateFlg === 'delete') && arr.findIndex(a => v.BargainID === a.BargainID) < 0) {
              arr.push(v);
            }
          })
        });
        return arr;
      },
      fromList() {
        let list = [
          {
            label: '下拉选项',
            key: 'TransferGoodsID',
            type: 'input',
            notEmpty: true,
            disabled: true,
          },
          {
            label: '货转日期',
            key: 'ScullDate',
            type: 'datePicker',
            default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
            disabled: this.editStart,
          },
          {
            label: '划入提单号',
            key: 'InBLNO',
            type: 'input',
            disabled: this.editStart,
          },
          {
            label: '产品',
            key: 'GoodsID',
            type: 'select',
            showDialog: true,
            tips: '...',
            list: this.refGoodsList,
            labelName: 'Name',
            value: 'GoodsID',
            disabled: this.editStart,
            must: true
          }, {
            label: '划入客户',
            key: 'InGuestID',
            type: 'select',
            showDialog: true,
            tips: '...',
            list: this.guestIDList,
            labelName: 'Name',
            value: 'GuestID',
            disabled: this.editStart,
            must: true
          }, {
            label: '转出客户',
            key: 'OutGuestID',
            type: 'select',
            showDialog: true,
            tips: '...',
            list: this.outGuestIDList,
            labelName: 'Name',
            value: 'GuestID',
            disabled: this.editStart,
            must: true
          },
          {
            label: '划入合同号',
            key: 'InBargainID',
            type: 'input',
            disabled: this.editStart,
          },
          {
            label: '免仓期',
            key: 'FreeDays',
            type: 'input',
            disabled: this.editStart,
            contentType: 'number',
          },
          {
            label: '货损率',
            key: 'ReasonWaste',
            type: 'input',
            must: true,
            disabled: this.editStart,
            contentType: 'number',
          }, {
            label: '转让费用',
            key: 'IsScullFee',
            default: true,
            type: 'switch',
            disabled: this.editStart,
            contentType: 'number',
          }, {
            label: '下家承担费用',
            key: 'isnext',
            type: 'switch',
            default: '0',
            disabled: this.editStart,
            contentType: 'number',
          },
          {
            label: '制单人',
            key: 'OperatorName',
            type: 'input',
            disabled: true,
          },
          {
            label: '制单时间',
            key: 'CreateDate',
            type: 'datePicker',
            default: `${this.$utils.getTime(new Date())}`,
            disabled: true,
          },
          {
            label: '备注',
            key: 'Remark',
            width: 'all',
            type: 'input',
            disabled: this.editStart,
          },
        ];
        return list;
      },
      refGoodsDefaultParams() {
        let info = {
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_Goods',
        };
        return info;
      },
      enclosureAction() {
        return [
          {width: 160, title: '附件描述', field: 'explain'},
          {width: 160, title: '附件名称', field: 'annexname'},
          {width: 160, title: '添加人', field: 'operatorid'},
          {width: 160, title: '添加时间', field: 'adddate'},
          {width: 160, title: '编辑', field: 'edit'},
        ]
      },
      batchFilterData() {
        let arr = [];
        this.batchNumberList.forEach(itme => {
          if (itme.updateFlg !== 'delete') {
            arr.push(itme);
          }
        });
        return arr;
      },
    },
    activated() {
      if (this.id !== this.$route.query.id) {
        this.init();
      }
    },
    mounted() {

      this.editModleHeight = window.document.body.clientHeight - 139;
      this._getDataList(this.refGoodsDefaultParams, this.goodsDefaultValue, 'refGoodsList');
      this.getRefVGuestAPI();
      this.batchInitCol();
      this.getBargain();

    },
    methods: {
      async getBargain() {
        const {bean} = await this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_TankGoodsBargain',
          params: {
            accountId: this.userInfor.accountId,
            goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          },
        });
        this.TankIDList = bean;
      },
      btnConfirm(F, pf, str, par,) {
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof F === "function") F(pf, par);
        });
      },
      getSummaries(param) {
        const countList = ['CanNumber', "Number"];
        const countObj = {
          CanNumber: {
            unit: ' ',
          }, Number: {
            unit: ' ',
          },
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] = sums[index].toFixed(3);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      selectOpt(row) {
        let orgIndex = this.batchNumberList.findIndex(x => {
          return x.uid == row.row.uid;
        });
        let refValue = this.TankIDList.filter(item => item.TankID === row.row.TankID);
        delete refValue[0].IsInTrade;
        Object.assign(this.batchNumberList[orgIndex], refValue[0], {updateFlg: 'add'});
      },
      async _getDataList(defaultParamsValue, defaultValues, list) {
        this.loading = true;
        let {url, type, params} = defaultParamsValue;
        const {bean} = await this.$services.post({
          url,
          type,
          params: Object.assign({}, params, {accountId: this.userInfor && this.userInfor.accountId})
        });

        this.loading = false;
        this[list] = bean;
      },
      init() {
        if (this.$route.query.type === 'add') this.listConfigAPI();

        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.MainOrder = this.$route.query.MainOrder;

        this.tableOriginData();
        if (this.$route.query.type === 'edit' || this.$route.query.type === 'info') {
          this.formInline.BillID = this.$route.query.id;
          this.formInline.TransferGoodsID = this.$route.query.MainOrder;
          this.detail(this.id);
        }

        if (this.$route.query.type === 'edit') {
          this.editStart = false;
        }
        // return;
        if (this.$route.query.type === 'add') {
          this.editStart = false;
          this.formInline.BillID = this.id;
          this.formInline.TransferGoodsID = this.$route.query.MainOrder;
        }

      },
      ...mapActions({
        getGoodDicList: 'dictionary/getGoodDicList',
        getGuestIDByConditionsList: 'dictionary/getGuestIDByConditionsList',
        getBargainIDByConditionsList: 'dictionary/getBargainIDByConditionsList',
        getRefGoodsByConditionsList: 'dictionary/getRefGoodsByConditionsList',
        getCargoTransferDetail: 'dictionary/CargoTransferDetailAction',
        getCarOrderList: 'dictionary/adminCarOrderListAction',
        getTGuestIDByConditions: 'dictionary/getTGuestIDByConditions',
        getBargainIDByConditions: 'dictionary/getBargainIDByConditions',
      }),
      orderTypeC(a, b) {
        let re;
        this.orderType === 'load' ? re = a : '';
        this.orderType === 'unload' ? re = b : '';
        return re;
      },
      listConfigAPI() {
        console.log('listConfigAPI');
        this.getBargainIDByConditions();
        this.getGoodDicList(this.OrderType);
        // this.getGuestIDByConditionsList(this.OrderType);
        this.getBargainIDByConditionsList(this.OrderType);
        this.getRefGoodsByConditionsList(this.OrderType);
        this.getCargoTransferDetail();

        this.getCarOrderList();
        // this.getTGuestIDByConditions(false);
        this.annexDetailAPI();
      },
      inputSelectEven(value) {
        this.formInline.BLNO = value.BLNO
      },
      querySearch(queryString, cb) {
        let restaurants = this.getBlnoList;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (restaurant.BLNO.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      // 车号文件上传
      licenseFileEven(file) {
        this.uploadFileAPI(file);
        return false;
      },
      uploadFileAPI(file) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          let base64 = e.target.result;
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'listExcelCarOrderList',
            params: {
              carListExcel: base64,
              suffix: this.getType(file.name),
            },
          }).then(res => {
            if (res.bean) {
              res.bean.forEach(v => {
                v.uid = this.$utils.getUid();
              });
              this.licenseNumberList = this.licenseNumberList.concat(res.bean);
            }
          });
        }
      },
      getType(file) {
        let filename = file;
        let index1 = filename.lastIndexOf('.');
        let index2 = filename.length;
        let type = filename.substring(index1, index2);
        return type;
      },
      // 按钮状态控制
      buttonStart(type) {
        let start = false;
        if ((this.$route.name === 'adminCargoTransferDetail') && type !== 1) {
          start = true;
        }
        switch (type) {
          case 1:
            if (!this.editStart || this.detailInfo.State !== 0) {
              start = true;
            }
            break;
          case 2:
            if (!this.editStart) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 3:
            if (this.editStart && this.detailInfo.State === 0) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 4:
            if (this.editStart && this.detailInfo.State === 0) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 6:
            if (this.detailInfo.State2 === 2) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 7:
            if (this.editStart) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 10:
            if (this.detailInfo.State === 0 || this.type === 'add') {
              start = true;
            }


            break;
        }
        return start;
      },
      // 时间范围控制
      pickerOptionsEnd(val) {
        let data = {};
        if (val === 'BLEndDate') {
          data = {
            disabledDate: time => (
              time.getTime() < dayjs(this.formInline.BLBeginDate).valueOf() - 24 * 1000 * 60 * 60
              // 可选范围重复24小时
            ),
          };
        }
        return data;
      },
      // 附件上传前的钩子
      beforeAvatarUpload(file) {
        if (this.desc) {
          this.annexUploadAPI(file);
        }
        else {
          this.$message({
            message: '请填写上传附件的说明',
            type: 'warning',
          });
        }
        return false;
      },
      // 单据的附件详情查询
      annexDetailAPI() {
        this.$services.post({
          type: 'ERP',
          url: 'annexDetail',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'TransferGoods',
            billsId: this.MainOrder,
          },
        }).then(res => {
          this.annexDetailList = res.bean;
        });
      },
      // 单据的附件上传
      annexUploadAPI(file) {
        let listid = 0
        if (this.annexDetailList.length > 0) {
          this.annexDetailList.forEach(itme => {
            if (listid < itme.listid) {
              listid = itme.listid;
            }
          });
        }
        const $loading = Loading.service({
          target: document.querySelector('div.contain'),
          lock: true,
          fullscreen: false,
          text: '附件上传中',
          background: 'transparent',
        });
        let data = {
          updateFlg: 'add',
          accountid: this.userInfor.accountId,
          tableid: 'TransferGoods',
          billsid: this.MainOrder,
          // listid: listid + 1,
          // showindex: listid + 1,
          explain: this.desc,
          annexname: file.file.name,
          operatorid: this.userInfor.userName,
          adddate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          annexsize: file.file.size / 1000,
        };
        this.$services.postUrlParams({
          type: 'ERP',
          url: 'annexUpload',
          urlParams: data,
          params: file.file,
        }).then(res => {
          $loading.close();
          if (res.code === '000') {
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          }
          this.desc = '';
          this.uploadFileDesc = false;
          this.annexDetailAPI();
        });
      },
      // 单据附件的下载
      fileDownload(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexDownload',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'TransferGoods',
            billsId: this.MainOrder,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.$utils.downLoad(res, itme.annexname)
        });
      },
      // 单据附件删除
      fileDelete(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexRemove',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'TransferGoods',
            billsId: this.MainOrder,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.annexDetailAPI();
          this.$message({
            message: '删除成功',
            type: 'success',
          });
        });
      },
      // 作废
      // 审核
      doAudit() {
        this.$services.post({
          type: 'ERP',
          url: 'doAudit',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'TransferGoods',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 296,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
            else {
              this.$message({
                message: '审核成功！',
                type: 'success',
              });
            }
          }
          this.editStart = true;
          this.detail(this.id);
          this.$forceUpdate();
          storage.$set({
            key: 'cargoTransferTable',
            parameter: true,
          });
        });
      },
      // 退审
      doCancleAudit() {
        this.$services.post({
          type: 'ERP',
          url: 'doCancleAudit',
          params: {
            pProId: 100022,
            aAccountId: this.userInfor.accountId,
            aTableId: 'TransferGoods',
            aBillId: this.id,
            aAuditResult: '1',
            aAuditStep: -1,
            pFuncId: 296,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 完成
      doFinish() {
        this.$services.post({
          type: 'ERP',
          url: 'doFinish',
          params: {
            aAuditResult: '1',
            pProId: 100022,
            aAccountId: this.userInfor.accountId,
            aTableId: 'TransferGoods',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 296,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
        });
      },
      // 作废
      operationDeleteEven() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'doBlankOut',
          params: {
            aAccountId: this.userInfor.accountId,
            aTableId: 'TransferGoods',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 296,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          res.code === '000' ? this.$message({
            message: '作废成功！',
            type: 'success',
          }) : '';
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$forceUpdate();
          storage.$set({
            key: 'cargoTransferTable',
            parameter: true,
          });
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 获取单据审核信息
      getCheckChecking() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckChecking',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'TransferGoods',
            billId: this.id,
          },
        }).then(res => {
          if (res.bean) {
            this.Step = res.bean.length;
          }
          else {
            this.Step = 0
          }
        });
      },
      // 获取单据审核流程信息，窗体加载时获取
      getCheckProcess() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckProcess',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'TransferGoods',
          },
        }).then(res => {
        });
      },
      openDialog(key, row = null, orgList) {
        let orgIndex;
        orgList ? orgIndex = orgList.findIndex(x => {
          return x.uid == row.row.uid;
        }) : '';
        if (orgIndex) this.currentTank = orgIndex;
        if (key === 'batch') {
          this.getInCarBatchId();
          return;
        }
        this[key] = !this[key];
      },
      async getInCarBatchId() {
        const {bean} = await this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_TankGoodsBargain',
          params: {
            accountId: this.userInfor.accountId,
            goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          },
        });
        bean.forEach((itme, key) => {
          itme.updateFlg = 'add';
        });
        // this.batchNumberList = bean;
      },
      // 表格初始化数据处理
      tableOriginData() {
        this.fromList.forEach(itme => {
          if (itme.key && !itme.notEmpty) this.$set(this.formInline, itme.key, '');
          if (itme.default) this.$set(this.formInline, itme.key, itme.default);
        });
        this.$set(this.formInline, 'OperatorID', this.userInfor.userName);
        this.$set(this.formInline, 'OperatorName', this.userInfor.nic);
        this.batchNumberCol.forEach(itme => {
          if (itme.field === 'IsInTrade' || itme.field === 'IsOutTrade' || itme.field === 'IsTax') {
            this.$set(this.batchNumberOriginData, itme.field, false);
          }
          else {
            this.$set(this.batchNumberOriginData, itme.field, null);
          }
        });
        this.batchNumberList = [];
      },
      // 取装卸车服务编号
      // 获取批号表格详情
      batchdetail(id) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'OW_Select_TransferGoodsTList',
          params: {
            accountId: this.userInfor.accountId,
            billId: String(id),
          },
        }).then(({bean}) => {
          this.batchNumberList = bean;
          this.batchNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
        });
      },

      // 获取台账详情
      detail(id, t) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'OW_WEB_Qry_OneTransferGoods',
          params: {
            accountId: this.userInfor.accountId,
            billId: String(id),
          },
        }).then(({bean}) => {
          bean = bean[0];
          this.$set(this.formInline, 'BillID', bean.BillID);
          this.$set(this.formInline, 'InGuestID', bean.InGuestID);
          this.$set(this.formInline, 'GoodsID', bean.GoodsID);
          this.$set(this.formInline, 'InBLNO', bean.InBLNO);
          this.$set(this.formInline, 'ScullDate', bean.ScullDate);
          this.$set(this.formInline, 'ScullType', bean.ScullType);
          this.$set(this.formInline, 'IsScullRight', bean.IsScullRight);
          this.$set(this.formInline, 'InBargainID', bean.InBargainID);
          this.$set(this.formInline, 'BearGuestID', bean.BearGuestID);
          this.$set(this.formInline, 'ReasonWaste', bean.ReasonWaste);
          this.$set(this.formInline, 'IsScullFee', bean.IsScullFee);
          this.$set(this.formInline, 'OperatorID', bean.OperatorID);
          this.$set(this.formInline, 'OperatorName', bean.OperatorName);
          this.$set(this.formInline, 'CreateDate', bean.CreateDate);
          this.$set(this.formInline, 'OutGuestID', bean.OutGuestID);
          this.$set(this.formInline, 'Remark', bean.Remark);
          this.$set(this.formInline, 'FreeDays', bean.FreeDays);
          this.$set(this.formInline, 'isnext', this.detailInfo.BearGuestID == this.formInline.InGuestID);
          this.batchNumberList = bean.transferGoodsTlists;
          this.batchNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
          if (this.type === 'add' && t) this.dataUpdate = true;
          this.detailInfo = bean;
          this.OrderType = bean.OrderType === 2 ? true : false;
          this.getBargainIDByConditions(this.OrderType);
          this.listConfigAPI();
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
            this.$forceUpdate();
          })
        });
      },
      // 添加table数据列
      addNewBatchNumberData(callback) {
        this.batchNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.batchNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.batchNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            AccountID: this.userInfor.accountId,
            ListID: this.batchNumberList.length + 1,
            ShowIndex: this.batchNumberList.length + 1,
            IsInTrade: true,
            ClearNumber: 0,
            State: 0,
            updateFlg: 'add',
          }),
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      getBargainEven() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? '08' : '09',
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'mainOrderGetBargainId',
          params,
        }).then(res => {
          this.bargainList = res.bean;
        });
      },
      // 客户弹出选择
      getRefVGuestAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_T_Guest',
          params,
        }).then(res => {
          this.guestIDList = res.bean;
        });
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'OW_Web_Get_OutGuest',
          params,
        }).then(res => {
          this.outGuestIDList = res.bean;
        });
      },
      selectRow(row) {
        this.$refs.pointSet.setCurrentRow(row);
      },
      clickFn(row) {
        this.$refs.pointSet.clearSelection();
        this.$refs.pointSet.toggleRowSelection(row);
      },
      // 用户选择表格事件
      batchNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.batchNumberUserSelectId = idAll;
      },
      licenseNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.licenseNumberUserSelectId = idAll;
      },
      // 删除
      batchNumberDelete() {
        if (this.batchNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除选中的' + this.batchNumberUserSelectId.length + '条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.batchNumberUserSelectId.forEach(itme => {
            this.batchNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.batchNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      //撤回接口
      revoke() {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'orderRevoke',
          params: {
            billId: this.detailInfo.BillID,
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          else if (res.bean[0].RetCode == 100) {
            this.$message({
              message: '撤回成功！',
              type: 'success',
            });
            this.detail(this.id);
            this.$forceUpdate();
            storage.$set({
              key: 'cargoTransferTable',
              parameter: true,
            });
          }
        });
      },
      doOperate(t) {
        switch (t) {
          case '0':
            this.checkForm();
            break;
          case '1':
            this.doAudit(this.currFpar);
            break;
          case '2':
            this.revoke();
            break;
          case '3':
            this.operationDeleteEven();
            break;
          default:
            break;

        }
      },
      checkForm() {
        this.$refs['topForm'].validate((valid) => {
          if (valid) {
            this.complete();
          } else {
            this.$message({
              message: '请将选项填写完整',
              type: 'warning',
            });
            return false;
          }
        });
      },
      toggleSelection() {
        this.$refs.batchTable.$children[0].clearSelection();
      },
      // 保存接口
      complete() {
        let batchNumber = 0;
        let start = false;
        this.toggleSelection();
        this.batchNumberList.forEach((itme, key) => {
          if (itme.CanNumber && String(itme.CanNumber)) itme.CanNumber = Number(itme.CanNumber);
          if (itme.Number && String(itme.Number)) itme.Number = Number(itme.Number);
          if (itme.updateFlg !== 'delete') {
            batchNumber = batchNumber + Number(itme.Number);
            let keyList = Object.keys(itme);
            keyList.forEach(keyListConter => {
              this.batchNumberCol.forEach(batchNumberColConter => {
                // if (batchNumberColConter.field === keyListConter && !batchNumberColConter.isNull && !String(itme[keyListConter])) {
                if (!batchNumberColConter.isNull && (itme[batchNumberColConter.field] === undefined || itme[batchNumberColConter.field] === null || itme[batchNumberColConter.field] === '')) {
                  this.$message({
                    message: `${batchNumberColConter.fieldAlias}数据未填写!!!!!`,
                    type: 'warning',
                  });
                  start = true;
                  return false;
                }
              });
            });
          }
          delete itme.uid;
          delete itme.id;
          itme.IsInTrade === null ? itme.IsInTrade = 0 : '';
          // itme.updateFlg === 'add' ? delete itme.ListID : '';
          if (!itme.updateFlg) itme.updateFlg = 'update';
        });
        if (start) return false;
        this.detailInfo.BearGuestID = this.userInfor.depCode;
        this.detailInfo.transferGoodsTlists = this.batchNumberList;

        this.detailInfo = Object.assign(this.detailInfo, this.formInline);
        this.detailInfo.updateFlg = (this.type === 'edit' || this.type === 'info') ? 'update' : 'add';
        this.detailInfo.IsScullFee = this.detailInfo.IsScullFee ? 1 : 0;
        this.detailInfo.BearGuestID = this.formInline.isnext ? this.formInline.InGuestID : this.userInfor.depCode;
        if (this.type === 'add') {
          this.detailInfo.AccountID = this.userInfor.accountId;
          this.detailInfo.State = 0;
          this.detailInfo.IsScullFee = Number(this.formInline.IsScullFee);
        }
        if (this.dataCheck()) return false;
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'saveTransferGoods',
          params: {
            data: JSON.stringify(this.detailInfo),
          },
        }).then(res => {
          if (res.bean) {
            this.$message({
              message: '保存成功',
              type: 'success',
            });
            this.editStart = true;
            if (this.type === 'add') {
              this.visitedViews.forEach(v => {
                if (v.path === this.$route.path) {
                  v.title = v.title.replace(/新增/, '') + '详情';
                }
              });
            }
            this.type = 'info';
            this.detail(this.id, true);
            storage.$set({
              key: 'cargoTransferTable',
              parameter: true,
            });
            this.$forceUpdate();
          }
        });
      },
      saveTest() {
        return new Promise((res, rej) => {
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'orderValidateBeforeSave',
            params: {
              accountId: this.userInfor.accountId,
              orderType: this.detailInfo.OrderType,
              goodsId: this.detailInfo.GoodsID,
            },
          }).then(re => {
            if (re.code === '000') {
              res();
            }
          })
        });

      },
      dataCheck() {
        let start = false;
        let arr = [
          {key: 'GoodsID', tips: '请选择产品',}
        ];
        arr.forEach(itme => {
          if (!this.detailInfo[itme.key]) {
            start = true;
            this.$message({
              message: itme.tips,
              type: 'warning',
            });
          }
        });
        return start;
      },
      batchInitCol() {
        this.CargoTransferDetail.length > 0 && (this.batchNumberCol = this.CargoTransferDetail.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.IsNull = itme.IsNull;
            if (info.field === 'TankID' || info.field === 'BatchID') {
              info.tips = '...';
              info.dialog = info.field === 'TankID' ? 'showTankID' : 'showBatchNo';
            }
            return info;
          })
        );
      },
      licenseInitCol() {
        this.carOrderList.length > 0
        && (this.licenseNumberClo = this.carOrderList.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.IsNull = itme.IsNull;
            return info;
          })
        );
      },
      clearBatchNumberList() {
        this.batchNumberList.forEach((batchInfo, batchKey) => {
          batchInfo.updateFlg = 'delete';
          this.batchNumberList.splice(batchKey, batchInfo);
        });
      }
    },
    watch: {
      'formInline.GoodsID'() {
        this.getBargain();
        this.getRefVGuestAPI();
      },
      CargoTransferDetail() {
        this.batchInitCol();
      },
      carOrderList() {
        this.licenseInitCol();
      },
      licenseNumberClo() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      batchNumberCol() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      'batchNumberList': function (newVal, oldVal) {
        let start = false
        newVal.forEach(itme => {
          if (itme.updateFlg !== 'delete') start = true;
          itme.IsInTrade == 1 ? itme.IsInTrade = true : '';
          itme.IsOutTrade == 1 ? itme.IsOutTrade = true : '';
          itme.IsTax == 1 ? itme.IsTax = true : '';
        });
        if (start && newVal[0]) {
          this.batchNumberListStyle = {
            'minHeight': '100px'
          };
          this.batchNumberListHeight = {
            minHeight: '100px',
            marginBottom: '10px'
          };
        }
        else {
          this.batchNumberListStyle = {
            'minHeight': '100px'
          };
          this.batchNumberListHeight = {
            minHeight: '100px',
            marginBottom: '0px'
          };
        }
        this.$forceUpdate();
      },
      'licenseNumberList': function (newVal, oldVal) {
        let start = false
        newVal.forEach(itme => {
          if (itme.updateFlg !== 'delete') start = true;
        });

        this.$forceUpdate();
      }
    }
  }
</script>
<style lang="scss">
  .edit {
    .halfW {
      width: 12.5% !important;
      .el-input__inner {
        padding: 0 3px !important;
      }
    }
    .allW {
      width: 100% !important;
      max-width: 100% !important;
    }
    .redTxt {
      textarea {
        color: #ff6464 !important;
      }
    }
    .batchTable {
      .el-table__body-wrapper {
        max-height: 150px !important;
      }
    }
    .el-table__body-wrapper {
      max-height: 300px;
      min-height: 80px;
    }
    .el-upload__input {
      display: none;
    }
    .standing_conter {
      overflow-y: scroll;
    }
    .el-input-group__append .el-button {
      margin: 0;
    }
    .edit_table {
      width: 100%;
      min-height: 400px;
    }
    .el-autocomplete {
      width: 100%;
      input {
        width: 100%;
      }
    }
    .standing-bar {
      .el-button--small {
        margin: 5px;
      }
    }
    .spanEdit {
      height: 34px;
      background: #F5F7FA;
      margin: 0 -3px -7px -3px;
      padding: 4px 10px;
    }
    .required {
      label {
        &:before {
          display: inline-block;
          content: '*';
          color: red;
        }
      }
    }
  }
</style>
